import { Button } from '@hivebrite/design-system/Button';

const FreeButton = ({ isSubmitting, submitForm, isValid = true }) => (
  <Button
    onClick={() => {
      submitForm();
    }}
    isLoading={isSubmitting}
    isDisabled={!isValid}
  >
    {s__('NetworkEvents|Submit')}
  </Button>
);

export default FreeButton;
